(function(mod) {
  if (typeof exports == "object" && typeof module == "object"){ // CommonJS
    mod(require("codemirror/lib/codemirror"));
  } else if (typeof define == "function" && define.amd) { // AMD
    define(["codemirror/lib/codemirror"], mod);
  } else { // Plain browser env
    mod(CodeMirror);
   }
})(function(CodeMirror) {
  "use strict";

  CodeMirror.defineMode("MatrixNutri", function (config) {
    const indentUnit = config.indentUnit;

    return {
      startState: function() {
        return {
          stringType: null,
          stack: []
        };
      },

      /*
       * Syntax highlight logic
       */
      token: function(stream, state) {
        if (!stream) {
          return null;
        }

        // parenthesis and comma management
        const result = parenthesisCommaManagamenet(stream, state);
        if (result!=null) {
          return result
        }

        // syntax highlight when matching the regexs defined
        const resultMatching = matchingRegex(stream, state);
        if (resultMatching!=null) {
          return resultMatching
        }

        return null;
      },

      /*
       * indent function used by the editor and when reindenting
       */
      indent: function(state, textAfter) {
        var depth = state.stack.filter(function (e) { return e === "block" }).length; //NOSONAR
        const indent =  (textAfter.match(/^\s*\),?\s*$/)) ? (depth - 1) * indentUnit : depth * indentUnit;
        return (indent >= 0) ? indent : 0;
      }
    };
  });
});
function parenthesisCommaManagamenet(stream, state){
  switch(stream.peek()) {
    case "(":
      stream.next();
      state.stack.unshift("parenthesis");
      return "operator";
    case ")":
      stream.next();
      switch(state.stack[0]){
        case "parenthesis":
          state.stack.shift();
          return "operator";
        case "function":
          state.stack.shift();
          return "builtin";
        case "block":
          state.stack.shift();
          return "keyword";
      }
  }
  return null;
}

function matchingRegex(stream, state){
     /*
     * REGEX to match types to highlight
     */
    // numbers
    const numbers = /\d+(.\d+)?/;

    // atoms
    const atoms = /TRUE|FALSE|NULL/;

    // operators
    const operators = /[-+/*=<>!^%]|&&|\|\|/;

    // blocks
    const blocks = /IF\(/;

    // functions
    const functions = /[A-Z0-9]+\(/;

    // constants
    const constants = /e|PI/;

    // variables
    const variable = /\[.*?\]/;

    // entry nutrients
    const entryNutrient = /@.*?@/;

    // entry nutrient with operation
    const entryNutrientWithOperation = /@.\S*?:.\S*?@/;

    // calculated nutrients
    const calculatedNutrient = /\$.*?\$/;

    if (stream.match(numbers)) {
      return "number";
    } else if (stream.match(atoms)) {
      return "atom";
    } else if (stream.match(operators)) {
      return "operator";
    } else if (stream.match(blocks)) {
      state.stack.unshift("block");
      return "keyword";
    } else if (stream.match(functions)) {
      state.stack.unshift("function");
      return "builtin";
    } else if (stream.match(constants)) {
      return "atom";
    } else if (stream.match(variable)) {
      return "variable-2";
    } else if (stream.match(entryNutrientWithOperation)) {
      return "variable-3";
    } else if (stream.match(entryNutrient)) {
      return "variable-4";
    } else if (stream.match(calculatedNutrient)) {
      return "variable-4";
    }else if (!stream.eatSpace()) {
      stream.next();
    }
    return null;
}
